// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataTransform from './useDataTransform'
import rdata from './data.json'
import React from 'react'
import Logic from './logic'

/** @type {import('Simple/types.js').Data} */
export default function ContentData(props) {
  let data = useDataTransform(props, rdata.value)

  return (
    <DataProvider
      context="tooth_chart"
      value={data}
      viewPath={props.viewPath}
    >
      <Logic {...props} />
    </DataProvider>
  )
}